module.exports = __webpack_public_path__ + "static/img/pay-eight.7d82114.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pay-eight.png
// module id = Cltw
// module chunks = 0